const mblLocationPopup = document.querySelector('state-popup');
const changeButton = document.getElementById('mbl-change-selection');
const currLElem= document.getElementById('mbl-current-state');
const currDMElem = document.getElementById('mbl-current-delivery-method');

function getPreferredLocation() {
  const stored = localStorage.getItem('preferredLocation');
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
}

const locationSel = getPreferredLocation();
if (locationSel) {
  updateHeaderLocation(locationSel.location, locationSel.method);
}

function updateHeaderLocation(selectedState = 'Not Selected', selectedDM = 'Not Selected') {
  currLElem.textContent = `${selectedState}`;
  currDMElem.textContent = `Method: ${selectedDM}`;
}

if(mblLocationPopup){
  changeButton.addEventListener('click', (event) => {
    mblLocationPopup.openPopup(event.currentTarget);
  });
}
